export default {
    plans: null,
    defaultPlan: null,
    error: {
        show: false,
        message: ''
    }
}



// WEBPACK FOOTER //
// ./src/store/plans/state.js